export const getSpiceText = (spiceLevel: number): string => {
  let spiceLevelVal = 'No';
  switch (spiceLevel) {
    case 0:
      spiceLevelVal = 'No';
      break;
    case 28:
      spiceLevelVal = 'Low';
      break;
    case 66:
      spiceLevelVal = 'Medium';
      break;
    case 100:
      spiceLevelVal = 'High';
      break;
    default:
      spiceLevelVal = 'No';
      break;
  }
  return spiceLevelVal;
};

export const getSpiceValue = (spiceLevel: string): number => {
  let spiceLevelVal = 0;
  switch (spiceLevel) {
    case 'No':
      spiceLevelVal = 0;
      break;
    case 'Low':
      spiceLevelVal = 28;
      break;
    case 'Medium':
      spiceLevelVal = 66;
      break;
    case 'High':
      spiceLevelVal = 100;
      break;
    default:
      spiceLevelVal = 0;
      break;
  }
  return spiceLevelVal;
};
